import { attach, createEffect, createEvent, sample } from 'effector'

import { attachI18n } from '@/shared/lib/i18n'
import { toast } from '@/shared/lib/toast'
import { showErrorNotificationFx } from '@/shared/ui'
import { createHideFx } from '@/shared/ui/modal'

import { chatapi, type MessageDeleteRequest } from '../../api'
import type { DialogParams, FormValues } from './types'

export const showFx = createEffect<DialogParams, string>()
export const hideFx = createHideFx(showFx)

export const backButtonClicked = createEvent()
export const hideButtonClicked = createEvent<FormValues & DialogParams>()

const messageDeleteFx = attach({ effect: chatapi.messageDelete })

export const $interactionDisabled = messageDeleteFx.pending

// -- Delete Message --
sample({
    clock: hideButtonClicked,
    fn: (data): MessageDeleteRequest => ({
        message_id: data.message_id,
        channel: data.channel,

        ban_user: data.ban,
        delete_all_from_user: data.deleteAll,
        report_spam: data.report,
    }),
    target: messageDeleteFx,
})

sample({
    clock: messageDeleteFx.failData,
    target: showErrorNotificationFx,
})

sample({
    clock: messageDeleteFx.done,
    target: hideFx,
})

sample({
    clock: messageDeleteFx.done,
    target: attachI18n(toast.successFx, 'TEXT_TOAST_SUCCESS'),
})
